export default __webpack_public_path__ + "static/media/32x32_AddShoppingCartRounded.60f0a681.svg";